import Pin from 'app/common/react/components/growth/unauth/pin/Pin';
import withImpressionLogging from 'app/common/lib/react/withImpressionLogging';

export default withImpressionLogging(Pin);
